module.exports = __webpack_public_path__ + "img/red_pin.4af12554.png";